import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/cn';

interface Props {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

/** "Nothing here yet" surface. Distinct from ErrorState — this is a
 * happy-path zero-count, not a failure. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: Props): JSX.Element {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-mb-border bg-mb-surface px-6 py-10 text-center',
        className,
      )}
    >
      {Icon ? (
        <div className="rounded-full bg-mb-surface-elev p-3 text-mb-text-muted">
          <Icon className="h-6 w-6" aria-hidden />
        </div>
      ) : null}
      <div>
        <div className="font-display font-semibold text-mb-text">{title}</div>
        {description ? (
          <div className="mt-1 text-sm text-mb-text-muted max-w-md">{description}</div>
        ) : null}
      </div>
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
